<template>
  <div>
    <Loader></Loader>

    <div v-if="getCompanyEmis && template">
      <div v-if="template == 'DocsAi'">
        <DocsAi></DocsAi>
      </div>
      <div v-else-if="template == 'reveal'">
        <RevealTemplate></RevealTemplate>
      </div>
      <div v-else-if="template == 'baronIT'">
        <BaronITSolutions></BaronITSolutions>
      </div>

      <div v-else>
        <WebsiteHeader
          @legal-services="getLegalServices"
          @get-website-banner="getWebsiteBanner"
          @get-company="checkCompany"
          @show-login="showLoginForm"
        ></WebsiteHeader>

        <v-content>
          <section id="hero">
            <v-row no-gutters>
              <v-img
                v-if="getUserCompany"
                :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'"
                :src="
                  websiteBanner
                    ? getApiUrl +
                      '/images/website_banner/' +
                      getUserCompany.emis +
                      '/' +
                      websiteBanner
                    : ''
                "
              >
                <v-theme-provider dark>
                  <div class="mt-14">
                    <v-row justify="center" align="center" class="white--text">
                      <v-col
                        class="white--text text-left"
                        :cols="$vuetify.breakpoint.smAndDown ? '12' : '7'"
                      >
                        <span
                          v-if="!Template2"
                          :class="[
                            $vuetify.breakpoint.smAndDown
                              ? 'display-1'
                              : 'display-2',
                          ]"
                          class="font-weight-light"
                          :style="{ color: getSecondaryColor }"
                          >WELCOME TO</span
                        >
                        <br />
                        <span
                          v-if="!Template2"
                          :class="[
                            $vuetify.breakpoint.smAndDown
                              ? 'display-2'
                              : 'display-3',
                          ]"
                          class="font-weight-black"
                          :style="{ color: getSecondaryColor }"
                          >{{ getAppTitle }}
                          <br />
                        </span>
                      </v-col>

                      <v-col
                        class="white--text text-right ml-14 mt-6"
                        :cols="$vuetify.breakpoint.smAndDown ? '12' : '4'"
                        v-if="showLogin"
                      >
                        <v-card
                          outlined
                          :style="{ 'background-color': 'rgb(0,0,0,0.1)' }"
                          v-if="!getAuthenticated"
                          min-width="350"
                        >
                          <v-tabs
                            v-model="tab"
                            centered
                            icons-and-text
                            background-color="rgb(0,0,0,0.1)"
                          >
                            <v-tabs-slider></v-tabs-slider>

                            <v-tab href="#tab-1">
                              Login
                              <v-icon>mdi-login</v-icon>
                            </v-tab>

                            <v-tab href="#tab-2">
                              Register
                              <v-icon>mdi-account</v-icon>
                            </v-tab>
                          </v-tabs>

                          <v-tabs-items
                            v-model="tab"
                            :style="{ 'background-color': 'rgb(0,0,0,0.1)' }"
                          >
                            <v-tab-item
                              v-for="i in 2"
                              :key="i"
                              :value="'tab-' + i"
                            >
                              <v-card
                                v-if="i == 1"
                                :style="{
                                  'background-color': 'rgb(0,0,0,0.1)',
                                }"
                              >
                                <Login></Login>
                              </v-card>
                              <v-card
                                v-else-if="i == 2"
                                :style="{
                                  'background-color': 'rgb(0,0,0,0.1)',
                                }"
                              >
                                <Register></Register>
                              </v-card>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-card>
                      </v-col>

                      <v-btn
                        class="align-self-end mx-2 mt-14"
                        fab
                        outlined
                        @click="$vuetify.goTo('#about-me')"
                        v-if="
                          !$vuetify.breakpoint.smAndDown &&
                          getUserCompany &&
                          !getUserCompany.emis == 'hands-of-hope-2022'
                        "
                      >
                        <v-icon>mdi-chevron-double-down</v-icon>
                      </v-btn>
                    </v-row>
                  </div>
                </v-theme-provider>
              </v-img>
            </v-row>
          </section>

          <T2HomeBlock1 v-if="Template2" class="mt-4"></T2HomeBlock1>
          <section id="about-me" v-else-if="Template1">
            <div class="py-12"></div>

            <div class="text-center">
              <h2 class="display-2 font-weight-bold mb-3">
                {{ getAppTitle }}
              </h2>

              <v-responsive class="mx-auto mb-8" width="56">
                <v-divider class="mb-1"></v-divider>

                <v-divider></v-divider>
              </v-responsive>

              <v-responsive
                class="mx-auto title font-weight-light mb-8"
                max-width="720"
                v-html="getUserCompany.about_us"
              ></v-responsive>

              <!-- <v-avatar class="elevation-12 mb-12" size="128">
            <v-img src="https://cdn.vuetifyjs.com/images/john.png"></v-img>
          </v-avatar>

          <div></div>

          <v-btn color="grey" href="https://vuetifyjs.com" outlined large>
            <span class="grey--text text--darken-1 font-weight-bold">Vuetify Documentation</span>
            </v-btn> -->
            </div>

            <div class="py-12"></div>
          </section>

          <section v-if="itsBaronIT" class="grey lighten-3">
            <div class="py-12"></div>
            <div class="text-center">
              <h2
                class="display-2 font-weight-bold mb-3"
                :style="{ color: getThemeColor }"
              >
                Pricing Plans
              </h2>

              <v-responsive class="mb-12">
                <v-divider
                  class="mb-1"
                  :style="{ color: getThemeColor }"
                ></v-divider>
              </v-responsive>

              <v-row>
                <v-col v-for="(plan, i) in plans" :key="i" cols="12" sm="3">
                  <v-card class="" color="grey lighten-5" flat>
                    <PricingTables :plan="plan"></PricingTables>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div class="py-12"></div>
          </section>

          <section v-else id="features" class="grey lighten-3">
            <div class="py-12"></div>

            <div class="text-center">
              <h2 class="display-2 font-weight-bold mb-3">Our Commitment</h2>

              <v-responsive class="mx-auto mb-12" width="56">
                <v-divider class="mb-1"></v-divider>

                <v-divider></v-divider>
              </v-responsive>

              <v-row>
                <v-col
                  v-for="({ icon, title, text }, i) in features"
                  :key="i"
                  cols="12"
                  md="4"
                >
                  <v-card class="py-12 px-4" color="grey lighten-5" flat>
                    <v-theme-provider dark>
                      <div>
                        <v-avatar :color="getThemeColor" size="88">
                          <v-icon large v-text="icon"></v-icon>
                        </v-avatar>
                      </div>
                    </v-theme-provider>

                    <v-card-title
                      class="justify-center font-weight-black text-uppercase"
                      v-text="title"
                    ></v-card-title>

                    <v-card-text class="subtitle-1" v-html="text"></v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>

            <div class="py-12"></div>
          </section>

          <section v-if="legalServicesKeys.length > 0" class="grey lighten-3">
            <div class="py-12"></div>
            <div class="text-center">
              <h2 class="display-2 font-weight-bold mb-3">Our Services</h2>

              <v-responsive class="mb-12">
                <v-divider
                  class="mb-1"
                  :style="{ color: getThemeColor }"
                ></v-divider>
              </v-responsive>

              <v-row>
                <v-col
                  v-for="(legalServiceCategory, i) in legalServicesKeys"
                  :key="i + Math.random()"
                  cols="12"
                  sm="4"
                >
                  <v-card class="" color="grey lighten-5" flat>
                    <OurServicesTable
                      :items="
                        getLegalServicesArray(
                          legalServiceCategory,
                          legalServicesObject
                        )
                      "
                      :title="legalServiceCategory"
                    ></OurServicesTable>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div class="py-12"></div>
          </section>

          <!-- <section id="blog">
          <div class="py-12"></div>
          <h2
            class="display-2 font-weight-bold mb-3 text-uppercase text-center"
          >
            Management Team
          </h2>
          <WebsiteImagesCarousel
            :images="smtImages"
            :folder="'smt'"
          ></WebsiteImagesCarousel>
          <div class="py-12"></div>
        </section> -->

          <!-- <section id="blog">
          <div class="py-12"></div>
          <h2
            class="display-2 font-weight-bold mb-3 text-uppercase text-center"
          >
            Posts & Announcements
          </h2>
          <WebsitePostSlides></WebsitePostSlides>
          <div class="py-12"></div>
        </section> -->

          <WebsiteContactUs v-if="Template2"></WebsiteContactUs>
        </v-content>

        <WebsiteFooter></WebsiteFooter>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import baronjs from "@/plugins/baron";
import companyJs from "@/plugins/company";
import WebsiteHeader from "@/components/SchoolWebsite/WebsiteHeader.vue";
import WebsiteFooter from "@/components/SchoolWebsite/WebsiteFooter.vue";
import WebsiteContactUs from "@/components/SchoolWebsite/WebsiteContactUs.vue";
import WebsiteImagesCarousel from "@/components/SchoolWebsite/WebsiteImagesCarousel.vue";
import WebsitePostSlides from "@/components/SchoolWebsite/WebsitePostSlides.vue";
import Login from "@/components/Login.vue";
import Register from "@/components/Register.vue";
import PricingTables from "@/components/SchoolWebsite/PricingTables.vue";
import OurServicesTable from "@/components/SchoolWebsite/OurServicesTable.vue";
import T2HomeBlock1 from "@/components/WebsiteT2/T2HomeBlock1.vue";
import RevealTemplate from "@/modules/WebsiteTemplates/RevealTemplate/RevealTemplate.vue";
import BaronITSolutions from "@/modules/WebsiteTemplates/BaronITSolutions/BaronITSolutions.vue";
import DocsAi from "@/modules/WebsiteTemplates/DocsAi/DocsAi.vue";
import Loader from "@/components/Loader.vue";

export default {
  components: {
    DocsAi,
    WebsiteHeader,
    WebsiteFooter,
    WebsiteContactUs,
    OurServicesTable,
    PricingTables,
    T2HomeBlock1,
    Login,
    Register,
    RevealTemplate,
    BaronITSolutions,
    Loader,
  },
  async mounted() {
    document.querySelector("title").textContent = this.getUserCompany.name;
    this.$store.commit("setLoader", true);
    await this.getCompanyEmisWithDomain();
    this.$store.commit("setLoader", false);
  },
  computed: {
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    getCompanyEmis() {
      return this.$store.getters.getCompanyEmis;
    },
    itsBaronIT() {
      return baronjs.itsBaronIT();
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getAppName() {
      return this.$store.getters.getAppName;
    },
    getAppTitle() {
      return baronjs.appName();
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    enableEditing() {
      return this.$store.getters.enableEditing;
    },
    features() {
      return [
        {
          icon: "mdi-shield-outline",
          title: "About Us",
          text: this.getUserCompany.about_us,
        },
        {
          icon: "mdi-update",
          title: "Our Vision",
          text: this.getUserCompany.vision,
        },
        {
          icon: "mdi-account-group-outline",
          title: "Our Misiion",
          text: this.getUserCompany.mission,
        },
      ];
    },
  },
  data() {
    return {
      companyEmis: null,
      showLogin: false,
      donationTemplate: ["hands-of-hope-2022"],
      revealTemplate: ["12824090253"],
      baronITTemplate: ["baron-007"],
      template: null,
      Template1: false,
      Template2: false,
      websiteBanner: null,
      plans: [
        // {
        //   title: "Free Plan",
        //   price: "0 / year",
        //   items: [
        //     "Unlimited Invoices",
        //     "Unlimited Quotations",
        //     "Clients Management",
        //     "Bulk Emails & Marketing",
        //     "One (1) User",
        //   ]
        // },
        {
          title: "Standard Plan",
          price: "1399 / year",
          items: [
            "Unlimited Invoices",
            "Unlimited Quotations",
            "Own Website & Branding",
            "Clients Management",
            "Image Gallery",
            "Professional Email Address",
            "Bulk SMS & Emails Marketing",
            "Ten 10 Users",
          ],
        },
        {
          title: "Premium Plan",
          price: "2999 / year",
          items: [
            "All Standard Features",
            "Point Of Sale",
            "Online Store",
            "HR & Payroll",
            "Unlimited Users",
          ],
        },
        {
          title: "Legal Plan",
          price: "4499 / year",
          items: [
            "All Premium Features",
            "Online FIle Manager",
            "Matter Management",
            "Legal Billing",
            "Medical / Professional Billing",
          ],
        },
      ],
      legalServicesObject: null,
      legalServicesKeys: [],
      smtImages: [],
      tab: null,
      images: [],
      websiteBanners: [],
    };
  },
  methods: {
    getCompanyEmisWithDomain() {
      this.template = null;
      const domain = window.location.hostname;
      this.$store.commit("setLoader", true);
      axios
        .postData("/get-company-emis-with-domain", { domain })
        .then((emis) => {
          emis = emis.toString();
          this.$store.commit("setCompanyEmis", emis);
          this.$store.commit("setLoader", false);
          this.getLogos(emis);
        });
    },
    async getLogos(emis) {
      this.images = await axios.postData("/get-logos-for-given-company", {
        folder: "logos",
        emis: emis,
      });

      await this.setTemplate(emis);
    },
    async setTemplate(emis) {
      this.$store.commit("setLoader", true);
      const data = await companyJs.getSiteInfo(emis, this);
      this.$store.commit("setLoader", false);
      if (emis == "docs-ai") {
        this.template = "DocsAi";
      } else if (this.baronITTemplate.includes(emis)) {
        // this.$store.commit("setLoader", true);
        // await this.getWebsiteBanner(emis);
        // this.$store.commit("setLoader", false);
        this.template = "baronIT";
      } else if (this.revealTemplate.includes(emis)) {
        this.$store.commit("setLoader", true);
        await this.getWebsiteBanner(emis);
        this.$store.commit("setLoader", false);
        this.template = "reveal";
      } else if (this.donationTemplate.includes(emis)) {
        this.$store.commit("setLoader", true);
        await this.getWebsiteBanner(emis);
        this.$store.commit("setLoader", false);
        this.template = "donation";
      } else {
        this.$store.commit("setLoader", true);
        await this.getWebsiteBanner(emis);
        this.$store.commit("setLoader", false);
        this.template = "default";
      }
    },
    async getWebsiteBanner(emis) {
      const websiteBanners = await axios.postData(
        "/get-company-website-banner",
        { emis }
      );

      if (websiteBanners[0]) {
        this.websiteBanner = websiteBanners[0];
        this.$emit("get-website-banner", websiteBanners[0]);
      } else {
        this.$emit("get-website-banner", null);
      }
    },

    checkCompany(company = null) {
      if (company && company.emis == "hands-of-hope-2022") {
        this.showLogin = false;
      } else {
        this.showLogin = true;
      }

      if (company) {
        if (this.donationTemplate.includes(company.emis)) {
          this.Template2 = true;
        } else {
          this.Template1 = true;
        }
      } else {
        if (this.donationTemplate.includes(this.getUserCompany.emis)) {
          this.Template2 = true;
        } else {
          this.Template1 = true;
        }
      }
    },
    getImages(folder, emis) {
      this.$store.commit("setLoader", true);
      axios
        .postData("/auth/get-logos-for-given-company", {
          folder,
          emis,
        })
        .then((images) => {
          this.$store.commit("setLoader", false);
          if (folder == "smt") {
            this.smtImages = images;
          } else if (folder == "sgb") {
            this.sgbImages = images;
          }
        });
    },
    getLegalServices(legalServices) {
      this.legalServicesObject = legalServices;
      this.legalServicesKeys = Object.keys(legalServices);
    },
    showLoginForm() {
      this.showLogin = !this.showLogin;
    },
    getLegalServicesArray(key, Obj) {
      return Obj[key];
    },
  },
};
</script>

<style></style>
